module.exports = __webpack_public_path__ + "img/wlp.a275978c.png";